import React,{useState} from "react";
import "./Invoice.scss";
import QRCode from "react-qr-code";
import Logo from '../../assets/images/logo_black.png';
import { Drawer, Button } from 'antd';


import moment from "moment-jalaali";
import {StoreOnlineLike, StoreOnlineProduct} from "../OnlineProduct/onlineProductService";
import {OnlineSearch} from "../../Components";
import Expand from "react-expand-animated";

const ConvertToJalali = (date) =>{
    // console.log("Data : ",date)
    if(date){
        return  moment.utc(date.split('+')[0]).format(' HH:mm jDD-jMM-jYYYY');
    }
    return ""
}

function numberWithCommas(x) {
    // convert To toman
    // x= (x/10).toFixed(0)
    //add commas
    if(x){
        x= Math.round(x)
        return x?x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","):0;
    }else {
        return "0"
    }
}




function Invoice({factor}) {

    const [visible, setVisible] = useState(false);
    const [pro, set_pro] = useState({});

    const [attribExpand ,set_attribExpand] = useState(false);
    const [descExpand ,set_descExpand] = useState(false);

    const getProduct = async (pId) =>{
        // pId = "7xc6rxzyCc"
        showDrawer()
        try{
            const response = await StoreOnlineProduct(factor.merchant.uid,pId);
            console.log("TRE ",response);
            set_pro(response.data)
        }catch (e) {
            console.log(e)
        }
    }


    const showDrawer = () => {
        setVisible(true);
    };

    const onClose = () => {
        setVisible(false);
    };

    const like = async (pId)=>{
        try{
            // let pId = "7xc6rxzyCc"
            await StoreOnlineLike(factor.merchant.uid,pId);
            getProduct()
        }catch (e) {
            // console.log(e)
        }
    }

    return(
        <div className="invoice-container">
            <Drawer
                width={300}
                placement="right" onClose={onClose} visible={visible}>
                <div className="invoice-product-drawer">
                    <div className="invoice-product-drawer-header">

                    </div>
                    <div className="invoice-product-drawer-body">


                        {/*-----------------------------------------------------------------------*/}
                        <div className="online-product-container">
                            <div className="online-product-item" style={{margin:8}}>
                                <div className="like-sectoin" onClick={()=>{
                                    like(pro.uid)
                                }}>
                                    {pro && pro.is_liked?
                                        <i className="fa fa-heart"></i>:
                                        <i className="fa fa-heart-o"></i>
                                    }
                                </div>

                                <div className="img-section"  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                }}>
                                    <img src={pro.image} alt=""/>
                                </div>

                                <div className="info-section" style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center"
                                }}>
                                    <span>{pro.name}</span>
                                    <div className="price-section">
                                        <span style={{direction:"rtl"}} className="original-price">{numberWithCommas(pro.price_original)} </span>
                                        <span style={{direction:"rtl"}} className="price">{numberWithCommas(pro.price)} ریال </span>
                                    </div>
                                </div>
                            </div>

                            <div className="online-product-attr">
                                <div className="online-product-attr-item">
                                    <div className="online-product-attr-item-label"  onClick={()=>{
                                        set_attribExpand(!attribExpand)
                                    }}>

                                        <i className={attribExpand?"fa fa-angle-down":"fa fa-angle-left"}></i>
                                        <span>ویژگی محصولات</span>
                                    </div>
                                    <Expand open={attribExpand}>
                                        <div className="product-atrrib-row">
                                            <div className="attr-value">{pro && pro.weight?pro.weight:" - "}</div>
                                            <div className="attr-label">وزن : </div>
                                        </div>
                                        <div className="product-atrrib-row">
                                            <div className="attr-value">{pro && pro.brand ? pro.brand : " - "}</div>
                                            <div className="attr-label">برند : </div>
                                        </div>
                                        <div className="product-atrrib-row">
                                            {/*<div className="attr-value">{pro && pro.parent.name}</div>*/}
                                            <div className="attr-label">نوع : </div>
                                        </div>
                                    </Expand>
                                </div>


                                <div className="online-product-attr-item">
                                    <div className="online-product-attr-item-label"  onClick={()=>{
                                        set_descExpand(!descExpand)
                                    }}>
                                        <i className={descExpand?"fa fa-angle-down":"fa fa-angle-left"}></i>
                                        <span>توضیحات </span>
                                    </div>
                                    <Expand open={descExpand}>
                                        <p>
                                            {pro.des}
                                        </p>
                                    </Expand>
                                </div>

                            </div>

                        </div>
                        {/*-----------------------------------------------------------------------*/}


                    </div>
                </div>
            </Drawer>

            {factor.merchant?<div className="invoice-body">

                {/*Logo*/}
                <div className="invoice-logo">
                    {/*<img src={Logo} alt=""/>*/}
                    <span>{factor.merchant.mall.name}</span>
                </div>

                {/*Title*/}
                {/*<div className="invoice-title">*/}
                {/*    <span>صورتحساب دیجیتال کالا</span>*/}
                {/*</div>*/}

                {/*Merchant Info*/}
                <div className="invoice-merchant-info">
                    <div className="invoice-merchant-info-row-center">
                        <span>{factor.merchant.address}</span>
                    </div>
                    <div className="invoice-merchant-info-row">

                        <div style={{direction:'rtl'}}>
                            <span>شماره فاکتور : </span>
                            <span> {factor.client_invoice_id || factor.uid}</span>
                        </div>
                        <div>
                            <span>شعبه : </span>
                            <span>{factor.merchant.name}</span>
                        </div>
                    </div>

                    <div className="invoice-merchant-info-row">
                        <div>
                            <span>تلفن  : </span>
                            <span>44802587 - 021</span>
                        </div>
                        <div>
                            <span>تاریخ / ساعت : </span>
                            {factor.created?<span>{ConvertToJalali(factor.created)}</span>:null}
                        </div>
                    </div>

                </div>

                {/*product info*/}
                <div className="invoice-product-title">
                    <span>مشخصات کالا</span>
                </div>


                {/*table*/}
                <div className="invoice-table">

                    <div className="invoice-table-header-row">
                        <div className="invoice-table-header-col">
                            <span>تخفیف (ریال)</span>
                            <span>مبلغ کل (ریال)</span>
                        </div>
                        <div className="invoice-table-header-col">
                            <span>تخفیف هر واحد</span>
                            <span>واحد (عدد / کیلو )</span>
                        </div>
                        <div className="invoice-table-header-col">
                            <span>مصرف کننده</span>
                            <span>قیمت داروخانه</span>
                        </div>
                        <div className="invoice-table-header-col">
                            <span>نام کالا</span>
                            <span>   </span>
                        </div>
                    </div>

                    {factor.products && factor.products.map(product=>{
                        return(
                            <div className="invoice-table-body-row">
                                <div className="invoice-table-header-col">
                                    <span>{numberWithCommas(product.amount-product.payable_amount)}</span>
                                    <span>{numberWithCommas(product.payable_amount)}</span>
                                </div>
                                <div className="invoice-table-header-col">
                                    <span>{numberWithCommas(product.product.price_original-product.product.price)}</span>
                                    <span>{product.quantity}</span>
                                </div>
                                <div className="invoice-table-header-col">
                                    <span>{numberWithCommas(product.amount)}</span>
                                    <span>{numberWithCommas(product.payable_amount)}</span>
                                </div>
                                <div className="invoice-table-header-col link-name" onClick={()=>{
                                    getProduct(product.product.uid)
                                }}>
                                    <span>{product.name}</span>
                                </div>
                            </div>
                        )
                    })}




                </div>

                {/*summary table*/}
                <div className="invoice-summary">
                    <div className="invoice-summary-row">
                        <span className="invoice-summary-row-value">{factor.products.length}</span>
                        <span className="invoice-summary-row-title">تعداد کالا : </span>
                    </div>

                    <div className="invoice-summary-row">
                        <span className="invoice-summary-row-value">{numberWithCommas(factor.amount)}</span>
                        <span className="invoice-summary-row-title">مجموع قیمت مصرف کننده : </span>
                    </div>

                    <div className="invoice-summary-row">
                        <span className="invoice-summary-row-value">{numberWithCommas(factor.client_discount_amount)}</span>
                        <span className="invoice-summary-row-title">تخفیف عمومی داروخانه : </span>
                    </div>

                    <div className="invoice-summary-row">
                        <span className="invoice-summary-row-value"> {numberWithCommas(factor.discount_amount)} </span>
                        <span className="invoice-summary-row-title">تخفیف ویژه داروخانه : </span>
                    </div>

                    <div className="invoice-summary-row">
                        <span className="invoice-summary-row-value"> 0 </span>
                        <span className="invoice-summary-row-title">تخفیف ویژه اعضای باشگاه مشتریان داروخانه : </span>
                    </div>

                    <div className="invoice-summary-row">
                        <span className="invoice-summary-row-value"> 0 </span>
                        <span className="invoice-summary-row-title">تخفیف استفاده شده از امتیاز شما در باشگاه : </span>
                    </div>

                    <div className="invoice-summary-row">
                        <span className="invoice-summary-row-value total-col">{numberWithCommas(factor.payable_amount)}</span>
                        <span className="invoice-summary-row-value">جمع کل (ریال) : </span>
                        <span className="invoice-summary-row-title"> vat  22,170  </span>
                    </div>

                    <div className="invoice-summary-row">
                        <span className="invoice-summary-row-value">{numberWithCommas(factor.discount_amount_sum)}</span>
                        <span className="invoice-summary-row-title">سود شما از این خرید : </span>
                    </div>


                </div>

                <div className="invoice-payment-type-title">
                    <span>نحوه پرداخت</span>
                </div>

                {/*Payment table*/}
                <div className="invoice-payment-type-table">
                    <div className="invoice-payment-type-table-row">
                        <span className="invoice-payment-type-table-total">{numberWithCommas(factor.payable_amount)}</span>
                        <span className="invoice-payment-type-table-text"> {factor.payment_method==="online"?"آنلاین":"صندوق فروشگاه"}  </span>
                        <span className="invoice-payment-type-table-number">1</span>
                    </div>
                </div>

                {/*Barcode*/}
                <div className="invoice-barcode">
                    <QRCode size={128} value={factor.uid} />
                    <span>{factor.uid}</span>
                </div>

                {/*Message*/}
                <div className="invoice-message">
                    <p>در صورتیکه به اشتباه قیمت کالا در فاکتور خرید بالاتر از قیمت مصرف کننده درج شده بروی کالا باشد اختلاف قیمت را از صندوقدار دریافت نمایید</p>
                </div>

            </div>:null}

        </div>
    )

}

export default Invoice
